import { defaultDataIdFromObject, InMemoryCache } from '@apollo/client';
import { getApolloClient } from '@pendwa/common-browser/core/apollo/index.js';
import { APP_CONSTANTS } from '@pendwa/common/utils/constants.js';

const cache = new InMemoryCache({
  dataIdFromObject: (object: { [key: string]: any }) => {
    switch (object.__typename) {
      default:
        // do not just use uuid here as sometimes one object level might return nothing
        // and in another part of the graph, we have a similar structure with same uuid and that will return
        // nothing too
        return defaultDataIdFromObject(object);
    }
  },
}).restore(
  // @ts-ignore
  window[APP_CONSTANTS.APOLLO_STATE_META_NAME] || {}
);

export const apolloClient = getApolloClient({
  cache,
});
